export default __webpack_public_path__ + "static/LiteLLM_logo_black-c5e2f8773252338c66033a7db54cc667.png";